import { render, staticRenderFns } from "./MediakitCollection.vue?vue&type=template&id=47f1d358&"
import script from "./MediakitCollection.vue?vue&type=script&lang=js&"
export * from "./MediakitCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports